angular.module('unica_notification_template.notification_template_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// NOTIFICATION
		.state('app.notification_template', {
			url: '/notification-template',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/notification-template/templates/notification-template.html',
					controller: 'NotificationTemplateBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// NOTIFICATION TEMPLATE LIST
			.state('app.notification_template.list', {
				url: '/list/:event_id',
				views: {
					'notificationTemplateContent': {
						templateUrl: './modules/notification-template/templates/list.html',
						controller: 'NotificationTemplateListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Template Notifiche',
					parent: function($scope) {
						return 'app.notification.list({ event_id:' + $scope.event_id + ' })';
					}
				}
			})

			// NOTIFICATION TEMPLATE CREATE
			.state('app.notification_template.create', {
				url: '/create/:event_id',
				views: {
					'notificationTemplateContent': {
						templateUrl: './modules/notification-template/templates/create.html',
						controller: 'NotificationTemplateCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Template Notifica',
					parent: 'app.notification_template.list'
				}
			})

			// NOTIFICATION TEMPLATE EDIT
			.state('app.notification_template.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'notificationTemplateContent': {
						templateUrl: './modules/notification-template/templates/edit.html',
						controller: 'NotificationTemplateEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Template Notifica',
					parent: 'app.notification_template.list'
				}
			});


});
